import React, { useState } from "react";
import {
  Typography,
  Paper,
  DialogContent,
  Divider,
  Avatar,
  Chip,
  Tooltip,
  Popover,
  Collapse,
  Button,
  LinearProgress,
  IconButton,
  Dialog,
  Box,
  DialogContentText,
  DialogActions,
  CircularProgress,
} from "@mui/material";
import DialogTitle from "../../../components/DialogTitle";
import {
  Business as BusinessIcon,
  Face as FaceIcon,
  ArrowRightAlt as ArrowRightAltIcon,
  Description as DescriptionIcon,
  Timeline as TimelineIcon,
  WarningAmber as WarningAmberIcon,
  CheckCircle as CheckCircleIcon,
  SettingsBackupRestore as SetttingsBackupRestoreIcon,
} from "@mui/icons-material";
import Options from "./Options";
import DealForm from "../../../components/DealForm/DealForm";
import { useDispatch, useSelector } from "react-redux";
import {
  clearDealTL,
  getADeal,
  getDealStageOverRideView,
  getStagerulesBased,
  revertOverRideRules,
} from "../../../redux/modules/deals";
import AccessControl from "../../../components/AccessControl";
import getAccessFor from "../../../helpers/getAccessFor";
import DealNotes from "./DealNotes";
import DealTimeline from "./DealTimeline";
import { getAContactDetails } from "../../../redux/modules/leads";
import DealConfigure from "../../../components/DealConfigure/DealConfigure";
import { formatTime } from "../../../utils/timeConverter";
import { setAlert } from "../../../redux/modules/alert";
import CloseIcon from "@mui/icons-material/Close";
import { convertUTCToTimezone } from "../../../utils/format_date";
import { getBTemplates } from "../../../redux/modules/email";

function TaggedContacts({ contacts }) {
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  const contactDetails = useSelector((state) => state.leads.contactDetails);
  const [loading, setLoading] = useState(false);

  const handleClick = (event, cont) => {
    setLoading(true);
    dispatch(getAContactDetails(cont.contact_id))
      .then(() => {
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <div className="related-contacts-group">
      {contacts.map((cont, c) => (
        <Chip
          key={c}
          variant="outlined"
          color="primary"
          size="small"
          label={cont.name}
          avatar={
            <Avatar className="contact-avatar">{cont.name.slice(0, 1)}</Avatar>
          }
          onClick={(e) => handleClick(e, cont)}
          clickable
        />
      ))}
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <div className="contact-details-popover">
          {loading ? (
            <LinearProgress />
          ) : (
            <>
              <Typography className="contact__head" component="h3">
                Contact Name
              </Typography>
              <Typography className="contact__value">
                {(contactDetails && contactDetails.contact_name) || ""}
              </Typography>
              {contactDetails && contactDetails.emails.length ? (
                <Typography className="contact__head" component="h3">
                  Emails
                </Typography>
              ) : null}
              {contactDetails &&
                contactDetails.emails.map((email, t) => (
                  <Typography key={t} className="contact__value">
                    {email}
                  </Typography>
                ))}
              {contactDetails && contactDetails.mobiles.length ? (
                <Typography className="contact__head" component="h3">
                  Phone Numbers
                </Typography>
              ) : null}
              {contactDetails &&
                contactDetails.mobiles.map((mobile, m) => (
                  <Typography key={m} className="contact__value">
                    {mobile}
                  </Typography>
                ))}
            </>
          )}
        </div>
      </Popover>
    </div>
  );
}

function DealItem({
  deal,
  stage,
  account = {},
  currencies,
  isOverride = false,
  selectedPipe,
  renderDeal,
  setRenderDeal,
  disabled,
}) {
  const [open, setOpen] = useState(false);
  const [edit, setEdit] = useState(false);
  const dealDetails = useSelector((state) => state.deals.dealDetails);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState();
  const [openNotes, setON] = useState(false);
  const [openTL, setTL] = useState(false);
  const [configure, setConfigure] = useState(false);
  const [dealStageRuleData, setDealStageRuleData] = useState({});
  const [openOverRide, setOpenOverRide] = useState(false);
  const [ruleLoading, setRuleLoading] = useState(true);
  const currentTZ = useSelector((state) => state.auth.timezone);

  const onOpenDetails = () => {
    setLoading(true);
    setRuleLoading(true);
    dispatch(getADeal(deal.deal_id)).then(() => {
      setLoading(false);
      setOpen(true);
    });

    // First: Fetch override rules
    dispatch(getDealStageOverRideView(deal.deal_id))
      .then((response) => {
        const overrideRule = response?.result?.rule || {};
        if (overrideRule && Object.keys(overrideRule).length > 0) {
          // We have override rules → set them
          setDealStageRuleData(overrideRule);
          setRuleLoading(false);
        } else {
          // No override → fetch default rules
          dispatch(getStagerulesBased(deal?.deal_stage, deal?.deal_pipeline))
            .then((res) => {
              setRuleLoading(false);
              setDealStageRuleData(res?.rules?.[0] || {});
            })
            .catch(() => {
              setRuleLoading(false);
            });
        }
        setLoading(false);
      })
      .catch(() => {
        setRuleLoading(false);
      });
  };

  const onDetailsClose = () => {
    setOpen(false);
    setEdit(false);
    setON(false);
    setTL(false);
    dispatch(clearDealTL());
    setConfigure(false);
    setDealStageRuleData({});
  };

  const onNotesClick = () => {
    setON(!openNotes);
    setTL(false);
  };

  const onTimelineClick = () => {
    setTL(!openTL);
    setON(false);
  };

  const owner =
    ((dealDetails && dealDetails.tagged_contacts) || []).find(
      (tc) => tc.owner === "1"
    ) || {};
  const currency =
    currencies.find((c) => c.code === deal.deal_value_currency) || {};

  //number of deals checking if only one there is no need of configure
  const pipelines = useSelector((state) => state.deals.pipelines);
  const dealPiplineId = deal?.deal_pipeline;

  const showConfigureButton = !disabled && selectedPipe !== "all";

  const handleRenderDeal = () => {
    setRenderDeal((renderDeal) => renderDeal + 1);
  };

  const handleConfirmOverRide = async () => {
    if (dealStageRuleData?.id) {
      dispatch(revertOverRideRules(dealStageRuleData?.id, deal?.deal_id))
        .then(() => {
          handleRenderDeal();
          // After successful revert, fetch the default rules
          dispatch(getDealStageOverRideView(deal?.deal_id))
            .then((res) => {
              setDealStageRuleData(res?.result?.rule || {});
            })
            .catch(() => {
              setDealStageRuleData({});
            });
          // Close the confirmation dialog
          setOpenOverRide(false);
        })
        .catch((error) => {
          console.error("Failed to revert override rules");
          dispatch(setAlert(error?.message || `Error`, "error"));
        });
    }
  };

  const buttonLabel =
    !dealStageRuleData ||
    Object.keys(dealStageRuleData).length === 0 ||
    dealStageRuleData?.rule_type === "pipeline"
      ? "Configure Over ride rule"
      : "Edit Override Rule Configuration";

  return (
    <>
      <Paper>
        <div
          className="deal-list-item"
          style={isOverride ? { border: "1px solid red" } : {}}
        >
          <div onClick={onOpenDetails} style={{ flexGrow: 4 }}>
            <Typography className="deal-title" variant="h6">
              {deal.deal_name}
            </Typography>
            <div className="deal-content">
              <Typography
                className="deal-value"
                variant="h6"
                style={{ marginTop: 10 }}
              >
                {currency.symbol}
                {deal.deal_value}
              </Typography>
              <Divider orientation="vertical" flexItem />
              <Typography className="deal-account" variant="caption">
                {account.name}
              </Typography>
            </div>
          </div>
          <div>
            {getAccessFor("delete_deals") ? (
              <Options
                deal_id={deal.deal_id}
                setLoading={setLoading}
                handleRenderDeal={handleRenderDeal}
              />
            ) : null}
          </div>
        </div>
        {loading ? <LinearProgress /> : null}
      </Paper>
      <Dialog
        open={open}
        onClose={onDetailsClose}
        scroll="body"
        // maxWidth="xl"
        maxWidth={false} // disable built-in maxWidth behavior
        PaperProps={{
          sx: {
            width: "600px", // fixed width
            maxWidth: "90vw", // responsive fallback
          },
        }}
      >
        {configure ? (
          <>
            <Collapse in={configure}>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                px={2}
                py={1}
              >
                <DialogTitle
                  component="div" // so it behaves like a plain div for flex layout
                  style={{ padding: 0, margin: 0 }}
                >
                  Configure {deal?.deal_name} Deal
                </DialogTitle>

                <IconButton
                  aria-label="close"
                  onClick={() => setConfigure(false)}
                  size="small"
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              </Box>
              <Divider />
              <DialogContent
                sx={{
                  minWidth: "300px",
                }}
              >
                <DealConfigure
                  cancel={() => setConfigure(false)}
                  deal={deal}
                  setRenderDeal={setRenderDeal}
                  renderDeal={renderDeal}
                  dealDetails={dealDetails}
                  setDealStageRuleData={setDealStageRuleData}
                  dealStageRuleData={dealStageRuleData}
                />
              </DialogContent>
            </Collapse>
          </>
        ) : (
          <Collapse in={!edit}>
            <DialogTitle onClose={onDetailsClose}>Deal Summary</DialogTitle>
            <Divider />
            <DialogContent>
              <div className="deal-name-wrapper">
                <Typography className="deal-summary-name" variant="h6">
                  {deal.deal_name}
                </Typography>
                <div style={{ display: "flex", gap: "10px" }}>
                  <AccessControl name="edit_deals">
                    <Button
                      className="bdr-btn-style-green"
                      color="primary"
                      onClick={() => setEdit(true)}
                    >
                      Edit Deal
                    </Button>
                  </AccessControl>
                </div>
              </div>
              <div className="deal-summary-basic">
                <BusinessIcon />
                <Tooltip title="Account" placement="top">
                  <Typography className="deal-account icon-text">
                    {account.name}
                  </Typography>
                </Tooltip>
                <Divider
                  className="summary-divider"
                  orientation="vertical"
                  flexItem
                />
                <FaceIcon />
                <Tooltip title="Owner" placement="top">
                  <Typography className="icon-text">{owner.name}</Typography>
                </Tooltip>
                <Divider
                  className="summary-divider"
                  orientation="vertical"
                  flexItem
                />
                <Tooltip title="Deal Value" placement="top">
                  <Typography variant="h5">
                    <span className="currency_sbl">{currency.symbol}</span>
                    {deal.deal_value}
                  </Typography>
                </Tooltip>
              </div>
              <Divider style={{ margin: 15 }} />
              <div
                className="deal-summary-basic deal-stage-show"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  justifyContent: "space-between",
                  flexWrap: "wrap",
                }}
              >
                <div
                  style={{ display: "flex", alignItems: "center", gap: "8px" }}
                >
                  <Typography>Deal stage</Typography>
                  <ArrowRightAltIcon />
                  <Typography variant="subtitle2">{stage}</Typography>
                </div>
                {showConfigureButton && (
                  <Button
                    className="bdr-btn-style-blue"
                    color="primary"
                    sx={{ mt: 1 }}
                    onClick={() => {
                      setEdit(false); // Collapse the Edit section
                      setConfigure(true); // Open the Configure section
                      dispatch(getBTemplates());
                    }}
                    // disabled={!showConfigureButton}
                  >
                    {buttonLabel || "Configure"}
                  </Button>
                )}
              </div>

              {ruleLoading ? (
                <Box py={2}>
                  <LinearProgress />
                </Box>
              ) : (
                (Array.isArray(dealStageRuleData)
                  ? dealStageRuleData.some(Boolean)
                  : Object.values(dealStageRuleData || {}).some(Boolean)) && (
                  <>
                    {/* Rule Type Heading */}
                    <Box
                      mb={2}
                      sx={{ display: "flex", justifyContent: "space-between" }}
                    >
                      <Typography variant="h6" color="primary">
                        {dealStageRuleData?.rule_type === "override"
                          ? "Override Rule"
                          : "Pipeline Rule"}
                      </Typography>
                    </Box>

                    {/* Auto-Move to Stage */}
                    <Box display="flex" alignItems="center" mb={1}>
                      <CheckCircleIcon color="success" sx={{ mr: 1 }} />
                      <Typography>
                        Auto-Move to
                        <Chip
                          label={
                            dealStageRuleData?.deal_stage_to_name || "----"
                          }
                          color="primary"
                          size="small"
                          variant="outlined"
                          sx={{ mx: 1 }}
                        />
                        in
                        <strong>
                          {" "}
                          {dealStageRuleData?.stage_transition_time === null
                            ? formatTime(
                                dealStageRuleData?.automove_to_stage_time
                              )
                            : convertUTCToTimezone(
                                dealStageRuleData?.automove_to_stage_time,
                                currentTZ
                              )}
                        </strong>
                      </Typography>
                    </Box>

                    {/* Follow-Up Email */}
                    <Box display="flex" alignItems="center" mb={1}>
                      <CheckCircleIcon color="success" sx={{ mr: 1 }} />
                      <Typography>
                        Follow-Up Email:&nbsp;
                        <Chip
                          label={
                            dealStageRuleData?.deal_template_name || "----"
                          }
                          color="primary"
                          size="small"
                          variant="outlined"
                          sx={{ mx: 1 }}
                        />
                        <strong>
                          {convertUTCToTimezone(
                            dealStageRuleData?.mail_schedule_time,
                            currentTZ
                          )}
                        </strong>
                      </Typography>
                    </Box>

                    {/* Override Warning */}
                    {dealStageRuleData?.rule_type === "override" && (
                      <>
                        <Box display="flex" alignItems="center">
                          <WarningAmberIcon color="warning" sx={{ mr: 1 }} />
                          <Typography>
                            Override Active&nbsp;
                            <Button
                              variant="outlined"
                              size="small"
                              color="warning"
                              endIcon={<SetttingsBackupRestoreIcon />}
                              onClick={() => setOpenOverRide(true)}
                            >
                              Revert to Default
                            </Button>
                          </Typography>
                        </Box>

                        <Dialog
                          open={openOverRide}
                          onClose={() => setOpenOverRide(false)}
                        >
                          <DialogTitle>Are you sure?</DialogTitle>
                          <DialogContent>
                            <DialogContentText>
                              This action will revert all changes to the default
                              settings. Do you want to continue?
                            </DialogContentText>
                          </DialogContent>
                          <DialogActions>
                            <Button
                              onClick={() => setOpenOverRide(false)}
                              color="primary"
                            >
                              Cancel
                            </Button>
                            <Button
                              onClick={handleConfirmOverRide}
                              color="warning"
                              autoFocus
                            >
                              Confirm
                            </Button>
                          </DialogActions>
                        </Dialog>
                      </>
                    )}
                  </>
                )
              )}

              <Divider style={{ margin: 15 }} />
              <div className="related-contacts">
                <Typography className="related-contacts-text">
                  Related contacts
                </Typography>
                <TaggedContacts
                  contacts={(dealDetails && dealDetails?.tagged_contacts) || []}
                />
              </div>
              <Divider />
              <div>
                <IconButton onClick={onNotesClick}>
                  <DescriptionIcon
                    className={openNotes ? "window-active-icon" : ""}
                  />
                </IconButton>
                <IconButton onClick={onTimelineClick}>
                  <TimelineIcon
                    className={openTL ? "window-active-icon" : ""}
                  />
                </IconButton>
              </div>
              <Collapse in={openTL}>
                <DealTimeline dealId={deal.deal_id} open={openTL} />
              </Collapse>
              <Collapse in={openNotes}>
                <Divider />
                <DealNotes dealId={deal.deal_id} />
              </Collapse>
            </DialogContent>
          </Collapse>
        )}

        <Collapse in={edit}>
          <DialogTitle onClose={onDetailsClose}>Edit Deal</DialogTitle>
          <Divider />
          <DialogContent>
            <DealForm
              deal={{ ...deal, ...(dealDetails || {}) }}
              cancel={() => setEdit(false)}
              edit
              disabled={disabled}
              setDealStageRuleData={setDealStageRuleData}
              handleRenderDeal={handleRenderDeal}
            />
          </DialogContent>
        </Collapse>
      </Dialog>
    </>
  );
}

export default DealItem;
